<div class="top-section">
    <h6 class="heading mb-0">{{ ss.texts()['common_setup'] }}</h6>
    <div class="flex items-center gap-6">
        <!-- Grace period warning (always shown first if conditions met) -->
        <app-svg name="importantMark" [color]="ss.theme().color14" width="20px" height="20px"
            *ngIf="setup().uid === cc.user.uid && ss.isInGracePeriod()" role="button"
            (click)="ds.featureExpiringSoon()"></app-svg>

        <!-- Dynamically rendered top bar actions (no static checks in loop) -->
        @for (action of topBarActionsWithoutSpecial(); track action.id) {
            @if (action.id === 'collaborators') {
                <!-- Special case: Collaborators with badge -->
                <span [class]="action.customClass" (click)="executeAction(action)" role="button">
                    <app-svg [name]="getCollaboratorIcon()" [color]="ss.theme().color12"></app-svg>
                    @if (getBadgeValue(action); as badgeValue) {
                        <span class="collab-badge">{{ badgeValue }}</span>
                    }
                </span>
            } @else if (action.id === 'viewEntries') {
                <!-- Special case: View entries as badge -->
                <span [class]="action.customClass" (click)="executeAction(action)" role="button">
                    {{ getBadgeValue(action) }}
                </span>
            } @else {
                <!-- Regular top bar icon -->
                <app-svg
                    [name]="action.icon"
                    (click)="executeAction(action)"
                    role="button"
                    [color]="ss.theme().color12">
                </app-svg>
            }
        }

        <!-- Kebab menu trigger (only if has items) -->
        @if (kebabAction() && showKebabMenu()) {
            <app-svg
                [name]="kebabAction()!.icon"
                [class]="kebabAction()!.customClass"
                [matMenuTriggerFor]="infoMenu"
                role="button"
                [color]="ss.theme().color12">
            </app-svg>
        }

        <!-- Close icon always at the end (right side) -->
        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>

        <!-- Kebab menu content -->
        <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu">
            @for (action of kebabMenuActions(); track action.id) {
                <button mat-menu-item (click)="executeAction(action)" [class]="action.id === 'collaborators' || action.id === 'collaboratorsKebab' ? 'common-menu-width' : ''">
                    @if (action.id === 'collaborators' || action.id === 'collaboratorsKebab') {
                        <!-- Special case: Collaborate menu item with badge -->
                        <span class="text-14-400 color-8 flex items-center">
                            <app-svg
                                [name]="action.icon"
                                class="ri-me-3 flex items-center justify-center"
                                [width]="'20px'"
                                [height]="'20px'"
                                style="width: 24px; height: 24px;"
                                [color]="ss.theme().color35">
                            </app-svg>
                            {{ ss.textsAny()[action.label] || action.label }}
                        </span>
                        <div class="menu-collaborator-add">
                            <span class="color-35 collaborator-count">{{ getBadgeValue(action) || 0 }}</span>
                        </div>
                    } @else {
                        <!-- Standard menu item -->
                        <span class="flex items-center">
                            <app-svg
                                [name]="action.icon"
                                [color]="action.destructive ? ss.theme().color11 : ss.theme().color35"
                                [class]="action.id === 'info' ? 'ri-pe-3' : 'ri-me-3'"
                                [height]="action.destructive ? '18px' : ''"
                                [width]="action.destructive ? '18px' : ''">
                            </app-svg>
                            <span class="text-14-400 color-8">
                                {{ ss.textsAny()[action.id === 'block' ? getBlockLabel() : action.label] || action.label }}
                            </span>
                        </span>
                    }
                </button>
            }
        </mat-menu>
    </div>
</div>
<div class="journal-setup-form ri-p-4">
    <form [formGroup]="journalSetupForm" #jSetupForm="ngForm" class="flex flex-col gap-8">
        <app-common-setup-type class="flex" featureType="journal" featureTypeContent="common_journal"
            [blocked]="deleted()" [isNewSetup]="!this.dataSetupId() ? true : false"
            [status]="featureStatus()"></app-common-setup-type>
        <app-input-text [control]="getFc('title')" name="meJournalTitle"
            [placeholder]="ss.texts()['common_titlePlaceholder']" maxLength="200" [submitted]="submitted"
            [noEnter]="true" [readonly]="role() !== 'owner'" [accessAlert]="true"
            [blocked]="deleted()"></app-input-text>
        <app-input-date-period name="meJournalDateRange" [startControl]="getFc('startAt')" [endControl]="getFc('endAt')"
            [repeatControl]="getFc('repeat')" [hiddenValues]="['OFF']" [readonly]="role() !== 'owner'"
            [accessAlert]="true" [blocked]="deleted()" [editAlert]="mode() === 'edit' ? true : false"
            [entityNameType]="'journal'" (cloneEvent)="cloneSetup()"></app-input-date-period>
        <app-input-time [control]="getFc('startAt')" [isTzAffected]="getFc('isTzAffected')"
            [isStartTimeSet]="getFc('isStartTimeSet')" [duration]="getFc('duration')" [reminder]="getFc('reminderAt')"
            [readonly]="role() !== 'owner'" [accessAlert]="true" [blocked]="deleted()"></app-input-time>
        <app-input-reminder [control]="getFc('reminderAt')" *ngIf="journalSetupForm.value.isStartTimeSet"
            [readonly]="role() !== 'owner'" [accessAlert]="true" [blocked]="deleted()"></app-input-reminder>
        <app-input-hashtag *ngIf="journalSetupForm.value.tags && journalSetupForm.value.tags.length > 0 && role() === 'owner'"
            [control]="getFc('tags')" [blocked]="deleted()" [accessAlert]="true"></app-input-hashtag>
        <p class="text-14-400 color-7 text-end" *ngIf="deleted()">{{ deletedAtString() }}</p>
    </form>

    <!-- <pre class="color-8">{{ journalSetupForm.value | json }}</pre> -->
</div>
<div class="bottom-section flex items-center justify-between ri-p-4 text-end ri-bt-2" *ngIf="!deleted()">
    <div class="flex items-center">
        <app-svg
            *ngIf="(!journalSetupForm.value.tags || journalSetupForm.value.tags.length === 0) && role() === 'owner'"
            name="hashtag" [color]="ss.theme().color35" class="ri-pe-6" role="button"
            (click)="openHashtagsDialog()"></app-svg>
    </div>
    <button type="submit" class="btn-text text-16-500 color-35" (click)="hasChanges() ? save() : closeDialog()">{{
        hasChanges() ? ss.texts()['common_save'] : ss.texts()['common_close'] }}</button>
</div>
<div class="bottom-section flex items-center justify-around ri-bt-2 ri-py-4" *ngIf="deleted()">
    <button class="btn-text text-16-400 color-11 ri-px-8" (click)="remove()">{{
        ss.texts()['common_buttonRemove'] }}</button>
    <button class="btn-text text-14-400 color-35 ri-px-8" (click)="restore()">{{
        ss.texts()['common_restore'] }}</button>
</div>